/* instagram-video-carousel — igvc namespace, glitch-free infinite loop */
(function () {

  function initIGVC(section) {
    if (!section || section.dataset.igvcInit === 'true') return;
    section.dataset.igvcInit = 'true';

    var track        = section.querySelector('[data-igvc-track]');
    var prevButton   = section.querySelector('[data-igvc-nav="prev"]');
    var nextButton   = section.querySelector('[data-igvc-nav="next"]');
    var loopEnabled  = section.dataset.loopCarousel === 'true';
    var loopSpeed    = (Number(section.dataset.loopSpeed) || 4) * 1000;
    var pauseOnHover = section.dataset.pauseOnHover !== 'false';
    var resumeDelay  = Math.max(1000, Number(section.dataset.resumeDelay) || 4000);
    var reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!track) return;

    /* ── State ──────────────────────────────────────────────── */
    var origSlides   = [];   /* real DOM slides only          */
    var allSlides    = [];   /* real + clones                 */
    var currentIndex = 0;
    var autoTimer    = null;
    var settleTimer  = null; /* setTimeout fallback for browsers without scrollend */
    var rafHandle    = 0;   /* rAF handle for frame-aligned commit              */
    var jumpPending  = false; /* true while we reposition scroll silently */
    var globalMuted  = true;
    var resumeTimer  = null;
    var isHovered    = false;
    var isFocused    = false;
    var isInteracting = false;

    /* Clone-set boundaries */
    var loopSpan      = 0;
    var leftBoundary  = 0;
    var rightBoundary = 0;

    /* ── Helpers ────────────────────────────────────────────── */
    function centeredLeft(slide) {
      return slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
    }

    function removeClones() {
      Array.from(track.querySelectorAll('[data-igvc-clone]')).forEach(function (el) {
        el.remove();
      });
    }

    function makeClone(slide) {
      var c = slide.cloneNode(true);
      c.setAttribute('data-igvc-clone', 'true');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      /* Let sound buttons get re-bound after cloning */
      Array.from(c.querySelectorAll('[data-igvc-sound]')).forEach(function (b) {
        b.removeAttribute('data-igvc-sound-bound');
      });
      return c;
    }

    /* ── Build slide list & clones ──────────────────────────── */
    function buildSlides() {
      removeClones();

      origSlides = Array.from(
        track.querySelectorAll('[data-igvc-slide]:not([data-igvc-clone])')
      );
      origSlides.forEach(function (s, i) {
        s.dataset.origIdx = i;
        s.removeAttribute('aria-hidden');
      });

      var canLoop = loopEnabled && origSlides.length > 1;

      if (canLoop) {
        /* Prepend reversed copies, append forward copies */
        origSlides.slice().reverse().forEach(function (s) {
          track.insertBefore(makeClone(s), track.firstChild);
        });
        origSlides.forEach(function (s) {
          track.appendChild(makeClone(s));
        });
      }

      allSlides = Array.from(track.querySelectorAll('[data-igvc-slide]'));

      /* Calculate the jump distance and safe-zone boundaries */
      if (canLoop && allSlides.length >= origSlides.length * 3) {
        var midFirst = allSlides[origSlides.length];
        var midLast  = allSlides[origSlides.length * 2 - 1];
        var preFirst = allSlides[0];

        loopSpan      = centeredLeft(midFirst) - centeredLeft(preFirst);
        leftBoundary  = centeredLeft(preFirst)  + loopSpan * 0.5;
        rightBoundary = centeredLeft(midLast)   + loopSpan * 0.5;
      } else {
        loopSpan = leftBoundary = rightBoundary = 0;
      }

      bindSoundButtons();
    }

    /* ── Silent position jump for seamless loop ─────────────── */
    function normalizeScrollPosition() {
      if (!loopSpan) return;
      var pos = track.scrollLeft;
      var needsJump = pos < leftBoundary || pos > rightBoundary;
      if (!needsJump) return;

      jumpPending = true;
      /* Briefly disable scroll-snap so the instant jump isn't fought by snap engine */
      track.style.scrollSnapType = 'none';
      track.scrollLeft = pos < leftBoundary ? pos + loopSpan : pos - loopSpan;

      /* Re-enable snap and clear jump flag after two frames */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.style.scrollSnapType = '';
          jumpPending = false;
        });
      });
    }

    /* ── Find the real slide closest to viewport center ─────── */
    function getActiveSlide() {
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = allSlides[0];
      var bestDist = Infinity;
      allSlides.forEach(function (s) {
        var dist = Math.abs((s.offsetLeft + s.clientWidth / 2) - centre);
        if (dist < bestDist) { bestDist = dist; best = s; }
      });
      return best;
    }

    function getSlideForIndex(idx) {
      var norm = ((idx % origSlides.length) + origSlides.length) % origSlides.length;
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = null; var bestDist = Infinity;
      allSlides.forEach(function (s) {
        if (Number(s.dataset.origIdx) !== norm) return;
        var dist = Math.abs((s.offsetLeft + s.clientWidth / 2) - centre);
        if (dist < bestDist) { bestDist = dist; best = s; }
      });
      return best;
    }

    /* ── Commit: apply igvc-active class + play video ───────── */
    function commitActive() {
      /* 1. Silently reposition if we drifted into clone territory */
      normalizeScrollPosition();

      /* 2. Find which slide is centred now */
      var active = getActiveSlide();
      currentIndex = Number(active.dataset.origIdx) || 0;

      /* 3. Apply class — single toggle, no rapid flicker */
      allSlides.forEach(function (s) {
        s.classList.toggle('igvc-active', s === active);
      });

      /* 4. Play only the active video */
      playActiveVideo(active);
    }

    /* ── Frame-aligned commit ───────────────────────────────── */
    function scheduleCommit() {
      cancelAnimationFrame(rafHandle);
      clearTimeout(settleTimer);
      rafHandle   = requestAnimationFrame(function () {
        settleTimer = setTimeout(commitActive, 20); /* tiny guard for momentum tail */
      });
    }

    /* ── Scroll handler — defer commit until scroll stops ────── */
    function onScroll() {
      if (jumpPending) return;
      scheduleCommit();
    }

    /* scrollend fires the moment momentum stops (Chrome / Safari 16+) */
    track.addEventListener('scrollend', function () {
      if (jumpPending) return;
      cancelAnimationFrame(rafHandle);
      clearTimeout(settleTimer);
      requestAnimationFrame(commitActive); /* one frame delay = paint-aligned */
    }, { passive: true });

    track.addEventListener('scroll', onScroll, { passive: true });

    /* ── Programmatic scroll to index ───────────────────────── */
    function scrollToIndex(idx, behavior) {
      var norm   = ((idx % origSlides.length) + origSlides.length) % origSlides.length;
      var target = getSlideForIndex(norm);
      if (!target) return;
      currentIndex = norm;
      track.scrollTo({ left: centeredLeft(target), behavior: behavior || 'smooth' });
    }

    function updateNavButtons() {
      var shouldDisable = origSlides.length < 2;

      [prevButton, nextButton].forEach(function (button) {
        if (!button) return;
        button.disabled = shouldDisable;
      });
    }

    /* ── Autoplay ───────────────────────────────────────────── */
    function startAuto() {
      if (
        !loopEnabled ||
        origSlides.length < 2 ||
        reducedMotionMedia.matches ||
        document.hidden ||
        isHovered ||
        isFocused ||
        isInteracting
      ) return;
      stopAuto();
      autoTimer = setInterval(function () {
        scrollToIndex(currentIndex + 1, 'smooth');
      }, loopSpeed);
    }

    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    function clearResumeTimer() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume(delay) {
      if (!loopEnabled) return;

      clearResumeTimer();
      resumeTimer = setTimeout(function () {
        isInteracting = false;
        startAuto();
      }, typeof delay === 'number' ? delay : resumeDelay);
    }

    function pauseForInteraction(delay) {
      if (!loopEnabled) return;

      isInteracting = true;
      stopAuto();
      scheduleResume(delay);
    }

    function handleEnvironmentChange() {
      stopAuto();
      isHovered = pauseOnHover && typeof track.matches === 'function' ? track.matches(':hover') : false;
      isFocused = track.contains(document.activeElement);

      if (document.hidden || reducedMotionMedia.matches) {
        clearResumeTimer();
        isInteracting = false;
      }

      startAuto();
    }

    /* ── Video playback ─────────────────────────────────────── */
    function playActiveVideo(activeSlide) {
      allSlides.forEach(function (s) {
        var v = s.querySelector('video');
        if (!v) return;
        if (s === activeSlide) {
          v.muted = globalMuted;
          v.defaultMuted = globalMuted;
          var p = v.play();
          if (p) {
            p.catch(function () {
              /* Browser blocked unmuted autoplay — silently fall back */
              v.muted    = true;
              v.defaultMuted = true;
              globalMuted = true;
              v.play().catch(function () {});
              syncSoundIcons();
            });
          }
        } else {
          v.pause();
          v.muted = true;
          v.defaultMuted = true;
        }
      });
      syncSoundIcons();
    }

    /* ── Sound toggle ───────────────────────────────────────── */
    function setSoundIcon(btn, muted) {
      var off = btn.querySelector('.igvc-sound-off');
      var on  = btn.querySelector('.igvc-sound-on');
      if (off) off.style.display = muted  ? 'block' : 'none';
      if (on)  on.style.display  = !muted ? 'block' : 'none';
      btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    }

    function syncSoundIcons() {
      section.querySelectorAll('[data-igvc-sound]').forEach(function (btn) {
        setSoundIcon(btn, globalMuted);
      });
    }

    function bindSoundButtons() {
      section.querySelectorAll('[data-igvc-sound]').forEach(function (btn) {
        if (btn.dataset.igvcSoundBound === 'true') return;
        btn.dataset.igvcSoundBound = 'true';
        setSoundIcon(btn, globalMuted);

        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          pauseForInteraction();
          globalMuted = !globalMuted;
          /* Apply immediately to active video */
          var active = allSlides.find(function (s) { return s.classList.contains('igvc-active'); });
          if (active) {
            var v = active.querySelector('video');
            if (v) {
              v.muted = globalMuted;
              v.defaultMuted = globalMuted;
              if (!globalMuted) {
                var p = v.play();
                if (p) p.catch(function () {
                  v.muted = true;
                  v.defaultMuted = true;
                  globalMuted = true;
                  syncSoundIcons();
                });
              }
            }
          }
          syncSoundIcons();
        });
      });
    }

    function bindNavButtons() {
      if (prevButton && prevButton.dataset.igvcNavBound !== 'true') {
        prevButton.dataset.igvcNavBound = 'true';
        prevButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          pauseForInteraction();
          scrollToIndex(currentIndex - 1, 'smooth');
        });
      }

      if (nextButton && nextButton.dataset.igvcNavBound !== 'true') {
        nextButton.dataset.igvcNavBound = 'true';
        nextButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          pauseForInteraction();
          scrollToIndex(currentIndex + 1, 'smooth');
        });
      }
    }

    /* ── Resize ─────────────────────────────────────────────── */
    window.addEventListener('resize', function () {
      buildSlides();
      /* Jump without animation, then re-commit */
      var target = getSlideForIndex(currentIndex);
      if (target) track.scrollLeft = centeredLeft(target);
      setTimeout(commitActive, 20);
      startAuto();
    });

    /* ── Pause autoplay on hover/focus ─────────────────────── */
    if (pauseOnHover) {
      section.addEventListener('mouseenter', function () {
        isHovered = true;
        stopAuto();
      });

      section.addEventListener('mouseleave', function () {
        isHovered = false;
        startAuto();
      });
    }

    section.addEventListener('focusin', function () {
      isFocused = true;
      stopAuto();
    });
    section.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!section.contains(document.activeElement)) {
          isFocused = false;
          startAuto();
        }
      }, 0);
    });

    track.addEventListener('pointerdown', function () {
      pauseForInteraction();
    });
    track.addEventListener('touchstart', function () {
      pauseForInteraction();
    }, { passive: true });
    track.addEventListener('wheel', function () {
      pauseForInteraction();
    }, { passive: true });

    document.addEventListener('visibilitychange', handleEnvironmentChange);
    if (typeof reducedMotionMedia.addEventListener === 'function') {
      reducedMotionMedia.addEventListener('change', handleEnvironmentChange);
    } else if (typeof reducedMotionMedia.addListener === 'function') {
      reducedMotionMedia.addListener(handleEnvironmentChange);
    }

    /* ── Kick off ───────────────────────────────────────────── */
    buildSlides();
    updateNavButtons();
    bindNavButtons();

    /* Position at first real slide (instant, no animation) */
    var firstReal = origSlides[0];
    if (firstReal) track.scrollLeft = centeredLeft(firstReal);

    commitActive();
    startAuto();
  }

  /* ── Page bootstrap ─────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('[data-instagram-carousel]').forEach(initIGVC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-instagram-carousel]');
    if (el) { el.dataset.igvcInit = 'false'; initIGVC(el); }
  });

})();
